import { use, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../css/create-quiz.css";

import {
  resetQuizForm,
  setQuizForm,
  setState,
  updateWinnerPrize,
} from "../redux/slice";
import { getLaws } from "../../components/LawCollegeQuiz/redux/lawCollegeSlice";
import { createQuiz, createQuizNew, imageUpload } from "../redux/thunk";
import { useNavigate } from "react-router-dom";
import { convertTermsToHtml } from "../utils";
// const getCompetitionTerms = (quizForm) =>
//   "1. Eligibility and Registration \n" +
//   "Participation is open to individuals who meet the specified criteria outlined in the quiz announcement (e.g., enrolled law students, legal interns and legal professionals).\n" +
//   "Participants must give accurate personal information during registration. False, incomplete, or misleading data may lead to disqualification.\n" +
//   "Multiple entries or impersonation will result in disqualification\n" +
//   "2. Access and Format\n" +
//   "The quiz is accessible via desktop/laptops/mobile devices.\n" +
//   "Each participant will have to register on the given portal to access the quiz and participate.\n" +
//   "The quiz will be accessible between the given timings only.\n" +
//   "No extensions will be granted beyond the allotted duration.\n" +
//   "Selection of answer can be done only once.\n" +
//   "The user will not be allowed to change the answer once selected.\n" +
//   `The quiz comprises *${quizForm.totalQuestions}* objective questions (e.g., MCQs, case-based scenarios), with a total duration of *${val1}* seconds (*${quizForm.questionDuration}* seconds per question).\n` +
//   "3. Scoring, Feedback & Result Declaration\n" +
//   "Performance in the quiz will be evaluated based on “Maximum Correct Answers in the Shortest Time”, determined electronically. Thus, in case of a tie(s), the participant who completed the Quiz at the earliest shall be considered the best performer.\n" +
//   `Each correct answer awards *${quizForm.correct}*\n` +
//   "Scores are auto-generated upon submission and are final.\n" +
//   "The correct answer will be displayed after every attempt made by the user\n" +
//   "In case of any technical failure, permitting reattempts will be the sole discretion of the DocMaster.\n" +
//   "Overall Results will be declared on [platform/website] once the quiz duration is over.\n" +
//   "4. Intellectual Integrity and Fair Play\n" +
//   "Participants must not resort to any unfair means including using external sources, devices, or assistance.\n" +
//   "Collaborative attempts, impersonation, or use of AI tools without explicit permission violate quiz ethics.\n" +
//   "All flagged violations will be reviewed, and the Docmaster reserves the right to disqualify entries or take further disciplinary steps.\n" +
//   "5. Technical Guidelines and Support\n" +
//   "Ensuring a stable internet connection and updated browser compatibility will be the sole responsibility of the participants.\n" +
//   "6. Certification and Recognition\n" +
//   "E-certificates will be issued to every participants with their achieved score\n" +
//   "Select winners may receive recognition via newsletter, social media, or sponsored prizes.\n" +
//   "7. Data Protection and Consent\n" +
//   "By registering, participants consent to the collection and limited use of their data for quiz administration and analysis.\n" +
//   "The organizing body complies with relevant data protection laws, including the IT Act, and adheres to institutional privacy standards.\n" +
//   "Data will not be shared externally without informed consent.\n" +
//   "8. Legal Disclaimer\n" +
//   "The quiz is a voluntary educational engagement and does not confer any legal rights, certification, or affiliation unless explicitly stated.\n" +
//   "Organisers will not accept any responsibility for entries that are lost, late, incomplete, or have not been transmitted due to computer error or any other error beyond the organiser’s reasonable control. Please note: Proof of submission of the entry is not proof of receipt of the same.\n" +
//   "In the event of unforeseen circumstances, organisers reserve the right to amend or withdraw the quiz at any time. For the avoidance of doubt, this includes the right to amend these terms and conditions.\n" +
//   "The organisers reserve all rights to disqualify or refuse participation to any participant if they deem participation or association of any participant is detrimental to the quiz, the organisers, or any partners of the quiz. The registrations shall be void if the information received by the organisers is illegible, incomplete, damaged, false, or erroneous.\n" +
//   "Organizers are not liable for any technical, personal, or academic outcome stemming from quiz participation.\n" +
//   "The organisers’ decision on the quiz will be final and binding.\n" +
//   "Any disputes shall be governed by the laws of India subject to Jurisdiction at Delhi. Expenses incurred for this purpose will be borne by the parties themselves.\n" +
//   "9. Grievance and Redressal\n" +
//   "Any grievances must be submitted in writing to [contact/email] within 2 days of quiz completion.\n" +
//   "The organizing team will aim to respond within 4-5 working days, and its decision shall be final.\n" +
//   "10. By entering the quiz, the participant accepts and agrees to the terms and conditions mentioned above.";

// const getPracticeQuizTerms = (quizForm) =>
//   "1. All registered users including law students, legal interns, educators, and professionals are eligible to access practice quizzes.\n" +
//   `2. This is a timed quiz with *${quizForm.totalQuestions}* questions to be answered in *${val1}* seconds but it is non-competitive.\n` +
//   "3. They are designed for self-paced learning and concept reinforcement.\n" +
//   "4. Scores are for personal tracking only and do not affect rankings or certification.\n" +
//   "5. To Participate, user needs to register on the website.\n" +
//   "6. The participants will be required to provide their name, email address, telephone number etc. By submitting the contact details, participants consent that the contact information can be used for the quiz.\n" +
//   "7. The quiz will start as soon as the participant clicks the “Start Quiz” button.\n" +
//   "8. Once submitted, an entry cannot be withdrawn.\n" +
//   "9. A participant can participate multiple times in a practice quiz.\n" +
//   "10. Topics may include Contract Law, Criminal Procedure, Environmental Law, Constitutional Law, Legal Drafting, and more.\n" +
//   "11. The participant will abide by all the rules and regulations of participating in the quiz.\n" +
//   "12. Quiz content is reviewed periodically to reflect changes in law, pedagogy, and user feedback.\n" +
//   "13. While every effort is made to ensure accuracy, users are advised to cross-reference with official statutes, case law, and academic resources for formal study or examination.\n" +
//   "14. Scores and progress may be tracked for personal use.\n" +
//   "15. Practice quizzes do not contribute to rankings, certifications, or rewards unless explicitly stated.\n" +
//   "16. Data may be used anonymously to improve platform recommendations and learning analytics.\n" +
//   "17. No personal data is shared with third parties without consent.\n" +
//   "18. Users must maintain academic integrity while using the platform. Any attempt to manipulate scores, impersonate users, or misuse content may result in restricted access or account suspension.\n" +
//   "19. DocMaster.Legal is not liable for any academic, professional, or legal outcomes resulting from quiz use.\n" +
//   "20. Practice quizzes are supplementary tools and do not replace formal legal education or professional advice.\n" +
//   "21. By entering the quiz, the participant accepts and agrees to the terms and conditions mentioned above.";

export default function CreateQuiz() {
  const { quizForm } = useSelector((state) => state.quizManagement);
  const { categories } = useSelector((state) => state.lawCollegeQuiz);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { winnerPrizes, prizeDescription } = quizForm;
  const [state, setStatee] = useState({
    allotments: [],
    quizType: 1,
    icon: null,
    count: "",
  });
  const [category, setCategory] = useState("");
  useEffect(() => {
    dispatch(getLaws());
  }, [dispatch]);
  const handleChangeNew = (key, value) => {
    setStatee((prev) => ({
      ...prev,
      [key]: value,
    }));

    dispatch(resetQuizForm());
  };

  const user = localStorage.getItem("userData");

  // const val1 = quizForm.totalQuestions * quizForm.questionDuration;

  function formatTerms(text) {
    if (!text) return "";

    const lines = text.split("\n").filter((l) => l.trim() !== "");

    let html = "<ol>";
    let inSubList = false;

    lines.forEach((line, idx) => {
      const trimmed = line.trim();

      // ✅ First line as heading (if it doesn’t start with a number.)
      if (idx === 0 && !/^\d+\./.test(trimmed)) {
        html = `<h3>${trimmed}</h3><ol>`;
        return;
      }

      // ✅ Main section (starts with number.)
      if (/^\d+\./.test(trimmed)) {
        if (inSubList) {
          html += "</ul>"; // close any open sublist
          inSubList = false;
        }
        // remove the leading number & dot
        const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
        html += `<li><strong>${withoutNum}</strong><ul>`;
        inSubList = true;
      }
      // ✅ Sub-point
      else {
        if (inSubList) {
          html += `<li>${trimmed}</li>`;
        } else {
          html += `<p>${trimmed}</p>`;
        }
      }
    });

    if (inSubList) html += "</ul>";
    html += "</ol>";

    return html;
  }

  // const getCompetitionTerms = () =>
  // "1.Eligibility and Registration\n" +
  //   "Participation is open to individuals who meet the specified criteria outlined in the quiz announcement (e.g., enrolled law students, legal interns and legal professionals).\n" +
  //   "Participants must give accurate personal information during registration. False, incomplete, or misleading data may lead to disqualification.\n" +
  //   "Multiple entries or impersonation will result in disqualification\n" +
  //   "2. Access and Format\n" +
  //   "The quiz is accessible via desktop/laptops/mobile devices.\n" +
  //   "Each participant will have to register on the given portal to access the quiz and participate.\n" +
  //   "The quiz will be accessible between the given timings only.\n" +
  //   "No extensions will be granted beyond the allotted duration.\n" +
  //   "Selection of answer can be done only once.\n" +
  //   "The user will not be allowed to change the answer once selected.\n" +
  //   "The quiz comprises [Number] objective questions (e.g., MCQs, case-based scenarios), with a total duration of [X seconds] seconds ([X second] seconds per question).\n" +
  //   "3. Scoring, Feedback & Result Declaration\n" +
  //   "Performance in the quiz will be evaluated based on “Maximum Correct Answers in the Shortest Time”, determined electronically. Thus, in case of a tie(s), the participant who completed the Quiz at the earliest shall be considered the best performer.\n" +
  //   `Each correct answer awards [Correct]\n` +
  //   "Scores are auto-generated upon submission and are final.\n" +
  //   "The correct answer will be displayed after every attempt made by the user\n" +
  //   "In case of any technical failure, permitting reattempts will be the sole discretion of the DocMaster.\n" +
  //   "Overall Results will be declared on [platform/website] once the quiz duration is over.\n" +
  //   "4. Intellectual Integrity and Fair Play\n" +
  //   "Participants must not resort to any unfair means including using external sources, devices, or assistance.\n" +
  //   "Collaborative attempts, impersonation, or use of AI tools without explicit permission violate quiz ethics.\n" +
  //   "All flagged violations will be reviewed, and the Docmaster reserves the right to disqualify entries or take further disciplinary steps.\n" +
  //   "5. Technical Guidelines and Support\n" +
  //   "Ensuring a stable internet connection and updated browser compatibility will be the sole responsibility of the participants.\n" +
  //   "6. Certification and Recognition\n" +
  //   "E-certificates will be issued to every participants with their achieved score\n" +
  //   "Select winners may receive recognition via newsletter, social media, or sponsored prizes.\n" +
  //   "7. Data Protection and Consent\n" +
  //   "By registering, participants consent to the collection and limited use of their data for quiz administration and analysis.\n" +
  //   "The organizing body complies with relevant data protection laws, including the IT Act, and adheres to institutional privacy standards.\n" +
  //   "Data will not be shared externally without informed consent.\n" +
  //   "8. Legal Disclaimer\n" +
  //   "The quiz is a voluntary educational engagement and does not confer any legal rights, certification, or affiliation unless explicitly stated.\n" +
  //   "Organisers will not accept any responsibility for entries that are lost, late, incomplete, or have not been transmitted due to computer error or any other error beyond the organiser’s reasonable control. Please note: Proof of submission of the entry is not proof of receipt of the same.\n" +
  //   "In the event of unforeseen circumstances, organisers reserve the right to amend or withdraw the quiz at any time. For the avoidance of doubt, this includes the right to amend these terms and conditions.\n" +
  //   "The organisers reserve all rights to disqualify or refuse participation to any participant if they deem participation or association of any participant is detrimental to the quiz, the organisers, or any partners of the quiz. The registrations shall be void if the information received by the organisers is illegible, incomplete, damaged, false, or erroneous.\n" +
  //   "Organizers are not liable for any technical, personal, or academic outcome stemming from quiz participation.\n" +
  //   "The organisers’ decision on the quiz will be final and binding.\n" +
  //   "Any disputes shall be governed by the laws of India subject to Jurisdiction at Delhi. Expenses incurred for this purpose will be borne by the parties themselves.\n" +
  //   "9. Grievance and Redressal\n" +
  //   "Any grievances must be submitted in writing to [contact/email] within 2 days of quiz completion.\n" +
  //   "The organizing team will aim to respond within 4-5 working days, and its decision shall be final.\n" +
  //   "10. By entering the quiz, the participant accepts and agrees to the terms and conditions mentioned above.";

  const getCompetitionTerms = () =>
    "*Hosting Legal*\n" +
    "Quiz is an initiative of DocMaster. It is a step aimed to empower its users with knowledge sharpening and rehearsals with current developments and increase in critical thinking around legal frameworks. Participating in DocMaster - Quiz is only subject to acceptance of its terms and conditions.\n\n" +
    "*Eligibility*\n" +
    "The quiz is open to all, it majorly focused for legal professionals, undergraduate and postgraduate law students from law colleges and universities.\n\n" +
    "*Registration*\n" +
    "Participants have to register first on the website of https://www.DocMaster.Legal as an advocate or a student which is totally free..\n" +
    "DocMaster will give option to practice on different topics.\n" +
    `While participating in a Quiz Competition every participant will have to submit its intent, where an OTP will be sent before the start of it.
There are no registration charges or fees applicable to participate in the Quiz.
Participants must complete personal information asked during registration. False, incomplete or misleading data may lead to disqualification or future problems to the participants.\n` +
    `Participants are expected to read all terms and conditions and guidelines before starting the use of DocMaster or to participate in the Quiz.  After registering, it would be treated a confirmation from the participants that they have gone through it and give acceptance of all terms and conditions of DocMaster.\n\n` +
    "*Quiz Format*\n" +
    "The quiz will be conducted only through online mode and would be available on https://www.DocMaster.Legal \n The Quiz schedule and timings will be announced from time to time at least 24 hours in advance.\nAll participants will themselves be responsible to check in advance their comfort and compatibility to participate, that is if they can execute the Quiz Process using laptop, desktop, tablet or by a mobile phone and their respective internet connection. The DocMaster can not be held responsible for any system glitches, slow internet or anything which arise from the side of the users. The DocMaster is not charging any fees or charges and offering its platform totally free.\n" +
    `The scoring system is designed to be calculated automatically upon each submission and shall be considered final at each level and step. No requests for re-evaluation or modification will be entertained as it’s a competition to learn and sharpen the skill. The quiz does not help in getting any degree or recognition. In the event of any technical disruption including connectivity issues, device failures or system glitches, the decision to permit re-attempts shall rest solely with DocMaster and will be considered at its discretion.\n` +
    "The overall results will be published on the dashboard immediately following the conclusion of the quiz. In the event of a tie, the participant who submits their responses earliest will be accorded a higher rank. The numbers, time and speed will be the essence of the quiz.\n" +
    "Our quiz system is designed to randomly assign and display different sets of questions to each participant during the same quiz session. This ensures a dynamic, fair, and secure assessment environment for all users.\n\n" +
    "*How to Play*\n" +
    `The quiz comprises a certain number of multiple-choice questions, each featuring four answer options. Participants will have [X seconds] seconds to respond to each question, with the timer beginning as soon as the question appears. Once the quiz starts, questions will be presented one at a time. To proceed, participants must select the correct option and click the "Submit" button to move to the next question. The quiz must be completed in a single uninterrupted session.\n\n` +
    "*Markings*\n" +
    "The quiz comprises [Number] objective questions (e.g., MCQs, case-based scenarios), with a total duration of [X seconds] seconds ([X second] seconds per question).\n\n" +
    "*Scoring, Feedback & Result Declaration*\n" +
    `Performance in the quiz will be evaluated based on “Maximum Correct Answers in the Shortest Time”, determined electronically. Thus, in case of a tie(s), the participant who completed the Quiz at the earliest shall be considered the best performer.
Each correct answer awards [Correct]
Scores are auto-generated upon submission and are final. The correct answer will be displayed after every attempt made by the user .In case of any technical failure, permitting reattempts will be the sole discretion of the DocMaster.
Overall Results will be declared on https://www.DocMaster.Legal  once the quiz duration is over.
` +
    `The quiz will cover legal domains, including and not limited to:
The upcoming quiz will cover a wide range of Indian laws, some of are listed here for your information but the question may also be raised from the acts and laws not mentioned here. These may include Constitutional Law, Civil Law, Family Law, Hindu Law, Company Law, Banking Law, Contract Law, Law of Torts, Law of Property, Law of Taxation, Insurance Law & Accidental Claims, Labour & Industrial Law, Consumer Protection, Arbitration, Conciliation & ADR, Environmental Law, Information Technology & Cyber Law, Intellectual Property Law, Land Law, Law relating to RTI, Law relating to Women & Child, Changes & Reforms, Professional Ethics, Jurisprudence, Indian Judicial System, Law and Media, Drafting of Pleading and Conveyancing and Legal English.\n` +
    "It will also include the newly introduced criminal law codes—the Bhartiya Nyaya Sanhita (BNS), Bhartiya Nagarik Suraksha Sanhita (BNSS) and Bhartiya Sakshya Adhiniyam (BSA) which have replaced the Indian Penal Code (IPC), the Code of Criminal Procedure (CrPC) and the Indian Evidence Act, respectively. This quiz will also test understanding of legal terminology and landmark judgments that have shaped Indian jurisprudence. In addition, a section will focus on features of https://www.DocMaster.legal.\n\n" +
    `*Conduct & Integrity*\n
Participants must maintain academic integrity and refrain from using unfair means, including but not limited to:` +
    "\n1.External assistance or collaboration\n 2. Use of multiple devices or accounts\n 3. Impersonation or proxy participation\n\n" +
    "Any violation will result in immediate disqualification and may be reported to the concerned institution. DocMaster reserves the right to monitor quiz activity and verify participant identity\n\n" +
    "*Data Usage & Privacy*\n" +
    "By registering, participants consent to the collection and use of their personal data for quiz administration, result processing and outreach communication. DocMaster will handle all data in accordance with its Privacy Policy, ensuring confidentiality and responsible usage. Participant data will not be sold or shared externally without informed consent, unless legally mandated.\n\n" +
    "*Legal Disclaimer*\n" +
    "Participation in the quiz constitutes a voluntary educational engagement and does not confer any legal rights, professional certification or institutional affiliation unless expressly stated by DocMaster.\n" +
    "DocMaster and its organisers shall not be held liable for any technical disruptions, personal inconveniences or academic consequences arising from participation in the quiz. Participation is voluntary, and users accept all risks associated with digital engagement.\n" +
    "Any disputes or claims related to the quiz shall be governed by the applicable laws of India and subject to the exclusive jurisdiction of the courts situated in Delhi.\n\n" +
    "*Grievance and Redressal*\n" +
    "All grievances or concerns must be formally submitted in writing to info@DocMaster.in within three days following the conclusion of the quiz. The organising committee will endeavour to review and respond within fifteen working days. All decisions made in this regard shall be final and binding.\n\n" +
    "*Amendments*\n" +
    "DocMaster solely reserves the right to revise the quiz format, schedule, content or associated terms at its discretion. Any such modifications will be duly communicated through the official website. Continued engagement with the quiz following these updates shall constitute deemed acceptance of the amended terms.\n\n" +
    "*Contact*\n" +
    `For queries, technical support or clarifications, please reach out to:
Email: info@DocMaster.in
Call us at +91 9289 44 0048
Website: https://www.DocMaster.Legal`;

  const getPracticeQuizTerms = () =>
    "1. All registered users including law students, legal interns, educators, and professionals are eligible to access practice quizzes.\n" +
    `2. This is a timed quiz with [Number] questions to be answered in [X seconds] seconds ([X second] seconds per question) but it is non-competitive.\n` +
    "3. They are designed for self-paced learning and concept reinforcement.\n" +
    "4. Scores are for personal tracking only and do not affect rankings or certification.\n" +
    "5. To Participate, user needs to register on the website.\n" +
    "6. The participants will be required to provide their name, email address, telephone number etc. By submitting the contact details, participants consent that the contact information can be used for the quiz.\n" +
    "7. The quiz will start as soon as the participant clicks the “Start Quiz” button.\n" +
    "8. Once submitted, an entry cannot be withdrawn.\n" +
    "9. A participant can participate multiple times in a practice quiz.\n" +
    "10. Topics may include Contract Law, Criminal Procedure, Environmental Law, Constitutional Law, Legal Drafting, and more.\n" +
    "11. The participant will abide by all the rules and regulations of participating in the quiz.\n" +
    "12. Quiz content is reviewed periodically to reflect changes in law, pedagogy, and user feedback.\n" +
    "13. While every effort is made to ensure accuracy, users are advised to cross-reference with official statutes, case law, and academic resources for formal study or examination.\n" +
    "14. Scores and progress may be tracked for personal use.\n" +
    "15. Practice quizzes do not contribute to rankings, certifications, or rewards unless explicitly stated.\n" +
    "16. Data may be used anonymously to improve platform recommendations and learning analytics.\n" +
    "17. No personal data is shared with third parties without consent.\n" +
    "18. Users must maintain academic integrity while using the platform. Any attempt to manipulate scores, impersonate users, or misuse content may result in restricted access or account suspension.\n" +
    "19. DocMaster.Legal is not liable for any academic, professional, or legal outcomes resulting from quiz use.\n" +
    "20. Practice quizzes are supplementary tools and do not replace formal legal education or professional advice.\n" +
    "21. By entering the quiz, the participant accepts and agrees to the terms and conditions mentioned above." +
    "*Scoring, Feedback & Result Declaration*\n" +
    "Performance in the quiz will be evaluated based on “Maximum Correct Answers in the Shortest Time”, determined electronically. Thus, in case of a tie(s), the participant who completed the Quiz at the earliest shall be considered the best performer." +
    "Each correct answer awards [Correct]\n" +
    `Scores are auto-generated upon submission and are final.
The correct answer will be displayed after every attempt made by the user
In case of any technical failure, permitting reattempts will be the sole discretion of the DocMaster.\n` +
    "Overall Results will be declared on https://www.DocMaster.Legal  once the quiz duration is over.\n" +
    `The quiz will cover legal domains, including and not limited to:
The upcoming quiz will cover a wide range of Indian laws, some of are listed here for your information but the question may also be raised from the acts and laws not mentioned here. These may include Constitutional Law, Civil Law, Family Law, Hindu Law, Company Law, Banking Law, Contract Law, Law of Torts, Law of Property, Law of Taxation, Insurance Law & Accidental Claims, Labour & Industrial Law, Consumer Protection, Arbitration, Conciliation & ADR, Environmental Law, Information Technology & Cyber Law, Intellectual Property Law, Land Law, Law relating to RTI, Law relating to Women & Child, Changes & Reforms, Professional Ethics, Jurisprudence, Indian Judicial System, Law and Media, Drafting of Pleading and Conveyancing and Legal English.
\n` +
    "It will also include the newly introduced criminal law codes—the Bhartiya Nyaya Sanhita (BNS), Bhartiya Nagarik Suraksha Sanhita (BNSS) and Bhartiya Sakshya Adhiniyam (BSA) which have replaced the Indian Penal Code (IPC), the Code of Criminal Procedure (CrPC) and the Indian Evidence Act, respectively. This quiz will also test understanding of legal terminology and landmark judgments that have shaped Indian jurisprudence. In addition, a section will focus on features of https://www.DocMaster.legal." +
    "";

  useEffect(() => {
    if (!quizForm) return;
    const val =
      state.quizType === 1 ? getCompetitionTerms() : getPracticeQuizTerms();

    dispatch(
      setQuizForm({
        key: "terms",
        value: val,
      })
    );
  }, [state.quizType, dispatch]);
  const handleChange = (key, value) => {
    // if (key === "topWinnersCount") {
    //   const count = Number(value);
    //   const prizes = Array.from(
    //     { length: count },
    //     (_, i) => winnerPrizes[i] || ""
    //   );
    //   dispatch(setQuizForm({ key: "topWinnersCount", value: count }));
    //   dispatch(setQuizForm({ key: "winnerPrizes", value: prizes }));
    // } else {
    // }

    dispatch(setQuizForm({ key, value }));
  };

  // Handle winner prize change
  const handlePrizeChange = (index, value) => {
    dispatch(updateWinnerPrize({ index, value }));
  };

  const removeAllotment = (difficulty_level) => {
    setStatee((prev) => ({
      ...prev,
      allotments: prev.allotments.filter(
        (a) => a.difficulty_level !== difficulty_level
      ),
    }));
  };
  // Add allotment for a difficulty level if not present
  const handleAllotmentChange = (difficulty_level) => {
    if (
      !state.allotments.some(
        (item) => item.difficulty_level === difficulty_level
      )
    ) {
      setStatee((prev) => ({
        ...prev,
        allotments: [...prev.allotments, { difficulty_level, percentage: "" }],
      }));
    }
  };
  // const handleAllotmentChangeNew = (law) => {
  //   if (!state.allotments.some((item) => item.law === law)) {
  //     setStatee((prev) => ({
  //       ...prev,
  //       allotments: [...prev.allotments, { law }],
  //     }));
  //   }
  // };

  const updatePercent = (index, value) => {
    const updated = [...state.allotments];
    updated[index].percentage = value;
    setStatee((prev) => ({ ...prev, allotments: updated }));
  };
  const userId = JSON.parse(localStorage.getItem("user"))?.id;

  const handleSubmit = async () => {
    const isPracticeQuiz = state.quizType === 2;
    const isLiveQuiz = state.quizType === 1;

    // ✅ Common validation
    const isCommonValid =
      quizForm.title?.trim() &&
      quizForm.start &&
      Number(quizForm.totalQuestions) > 0 &&
      Number(quizForm.questionDuration) > 0 &&
      quizForm.about?.trim() &&
      quizForm.terms?.trim() &&
      quizForm.quizType &&
      Array.isArray(state.allotments) &&
      state.allotments.length > 0;

    // ✅ Quiz-type specific validation
    const isPracticeValid =
      isPracticeQuiz &&
      quizForm.registrationStart &&
      quizForm.registrationEnd &&
      quizForm.registrationFeeMode &&
      quizForm.registrationCost !== "" &&
      isCommonValid;

    const isLiveValid = isLiveQuiz && category && isCommonValid;

    // if (!(isPracticeValid || isLiveValid)) {
    //   alert("Please provide all values");
    //   return;
    // }

    // ✅ Check allotment percentage
    if (
      isLiveQuiz &&
      state.allotments.reduce(
        (sum, a) => sum + Number(a.percentage || 0),
        0
      ) !== 100
    ) {
      alert("Total percentage of difficulty allotments must be exactly 100%");
      return;
    }

    // ✅ Date validations
    const now = Date.now();
    const regStart = Date.parse(quizForm.registrationStart);
    const regEnd = Date.parse(quizForm.registrationEnd);
    const startDate = Date.parse(quizForm.start);

    if (isLiveQuiz) {
      if (regStart <= now) {
        alert("Registration start date must be in the future.");
        return;
      }
      if (regEnd <= regStart) {
        alert("Registration end date must be after registration start date.");
        return;
      }
      if (startDate <= regEnd) {
        alert("Start date of quiz must be after registration end date.");
        return;
      }
    }

    // if (isPracticeQuiz && startDate <= now) {
    //   alert("Start date of quiz must be in the future.");
    //   return;
    // }

    if (state.quizType === 2 && !state.icon) {
      alert("please uplaod the icon for the practice quiz");
    } // ✅ Common body
    else {
      const commonBody = {
        title: quizForm.title,
        total_questions: Number(quizForm.totalQuestions),
        duration_per_question: Number(quizForm.questionDuration),
        marks_per_question: Number(quizForm.correct),
        negative_marks_wrong: Number(quizForm.wrong),
        negative_marks_skipped: Number(quizForm.skipped),
        about_quiz: quizForm.about,
        quiz_terms: quizForm.terms,
        quiz_type: Number(state.quizType),
        created_by: userId,
        // description: quizForm.description,
      };

      // ✅ Specific body per quiz type
      const body = isLiveQuiz
        ? {
            ...commonBody,
            allotments: state.allotments.filter(
              (a) => Number(a.percentage) > 0
            ),

            // allotments: state.allotments,
            registration_start_date: quizForm.registrationStart,
            registration_end_date: quizForm.registrationEnd,
            registration_fee:
              quizForm.registrationFeeMode === "free"
                ? 0
                : parseFloat(quizForm.registrationCost).toFixed(2),
            prizes: prizeDescription,
            start_date: quizForm.start,

            // quizForm.winnerPrizes.reduce((acc, val, idx) => {
            //   acc[(idx + 1).toString()] = parseFloat(val).toFixed(2);
            //   return acc;
            // }, {}),
            registration_type: quizForm.registrationFeeMode,
          }
        : {
            ...commonBody,
            allotments: [{ law: Number(category) }],
          };

      console.log("BOdy to snd", body);
      // ✅ API call
      if (window.confirm("Are you sure to create quiz")) {
        try {
          const res = await dispatch(createQuiz(body));
          console.log(res);
          if (state.quizType === 2) {
            const res2 = await dispatch(
              imageUpload({ image: state.icon, id: res?.payload?.quiz_id })
            );
            if (res2) {
              console.log(res2);
              alert(res2?.payload?.message || "image uploaded!");
            }
          }

          if (res) {
            if (res?.payload?.message === "Missing required fields") {
              // window.location.reload();
              alert(res?.payload?.message);
              navigate("/dashboard/create-quiz");
            } else {
              alert(res?.payload?.message || "Quiz created successfully");
              setStatee({ allotments: [] });
              dispatch(resetQuizForm());
              navigate("/dashboard/view-or-update-quizzes"); // window.location.reload();
            }
          }
        } catch (err) {
          console.error("Error creating quiz:", err);
          alert("Error creating quiz");
        }
      }
    }
  };

  const isFormValid = () => {
    return (
      quizForm.title?.trim() &&
      quizForm.start &&
      quizForm.totalQuestions &&
      quizForm.questionDuration &&
      quizForm.registrationStart &&
      quizForm.registrationEnd &&
      quizForm.registrationFeeMode &&
      quizForm.about?.trim() &&
      quizForm.terms?.trim() &&
      quizForm.quizType &&
      state.allotments
      // must be 1 or 2
    );
  };
  const totalAllotment =
    state.quizType === 1
      ? state.allotments.reduce((sum, a) => sum + Number(a.percentage || 0), 0)
      : 0;

  return (
    <div className="container-fluid w-100 mx-auto py-2 font-inter">
      <div className="row mx-auto w-100">
        <div className="col-md-12 w-100">
          <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
            Create Quiz
          </h3>
          <div
            className="bg-white mb-8 max-w-4xl mx-auto shadow rounded-3 p-4"
            style={{ height: "70vh", overflow: "auto" }}
          >
            {/* className="col-sm-9" Full-width Question input */}
            <div
              // className="row mb-3"
              style={{
                display: "flex",
                gap: "4%",
                flexDirection: "row",
                marginBottom: "2%",
              }}
            >
              <label>
                {/* // className="col-sm-3 col-form-label font-medium text-gray-700"> */}
                <strong> Quiz Type</strong>
              </label>
              <div>
                <label style={{ marginRight: "1rem" }}>
                  <input
                    type="radio"
                    name="quizType1"
                    value="1"
                    checked={state.quizType === 1}
                    onChange={(e) =>
                      handleChangeNew("quizType", Number(e.target.value))
                    }
                    required
                  />{" "}
                  Live Quiz
                </label>
                {/* &nbsp */}
                <label>
                  <input
                    type="radio"
                    name="quizType"
                    value="2"
                    // style={{marginLeft:}}
                    checked={state.quizType === 2}
                    onChange={(e) =>
                      handleChangeNew("quizType", Number(e.target.value))
                    }
                    required
                  />{" "}
                  Practice Quiz
                </label>
              </div>
            </div>
            {state.quizType !== "" ? (
              <>
                <div
                  style={{
                    display: "flex",
                    gap: "4%",
                    flexDirection: "row",
                    marginBottom: "2%",
                  }}
                >
                  <label style={{ fontWeight: 545 }}>
                    {/* // className="col-sm-3 col-form-label font-medium text-gray-700"> */}
                    {/* <strong> */}
                    Quiz Title
                    {/* </strong> */}
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className=" form-control"
                      placeholder="Enter quiz title"
                      value={quizForm.title}
                      onChange={(e) => handleChange("title", e.target.value)}
                      required
                      maxLength={30}
                    />
                    <span>{quizForm?.title.length}/30</span>
                  </div>
                </div>
                {/* <div className="row mb-3">
                  <label className="col-sm-3 col-form-label font-medium text-gray-700">
                    Quiz Description
                  </label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className=" form-control"
                      placeholder="Enter quiz title"
                      value={quizForm.description}
                      onChange={(e) =>
                        handleChange("description", e.target.value)
                      }
                      required
                      maxLength={80}
                    />
                    <span>{quizForm?.description.length}/80</span>
                  </div>
                </div> */}
                {/* 2-in-a-row layout for remaining fields */}
                {state.quizType === 1 ? (
                  <div>
                    <div style={{ display: "flex", gap: "2%" }}>
                      {["registrationStart", "registrationEnd", "start"].map(
                        (key, idx) => (
                          <div className="form-group" key={key}>
                            <label
                              className="form-label"
                              style={{ fontWeight: 545 }}
                            >
                              {
                                [
                                  "Registration Quiz Start Date",
                                  "Registration Quiz End Date",
                                  "Quiz Date",
                                ][idx]
                              }
                            </label>
                            <input
                              type="datetime-local"
                              className="form-input"
                              value={quizForm[key]}
                              onChange={(e) =>
                                handleChange(key, e.target.value)
                              }
                              required
                            />
                          </div>
                        )
                      )}
                    </div>
                    <div style={{ display: "flex", gap: "2%" }}>
                      {[
                        { key: "totalQuestions", label: "Total Question(s)" },
                        {
                          key: "questionDuration",
                          label: "Duration per Qn (in seconds)",
                        },
                        {
                          key: "totalDuration",
                          label: "Total Duration (in seconds)",
                        },
                      ].map(({ key, label }) => (
                        <div className="form-group" key={key}>
                          <label
                            className="form-label"
                            style={{ fontWeight: 545 }}
                          >
                            {label}
                          </label>
                          <input
                            type="number"
                            disabled={key === "totalDuration"}
                            min={1}
                            style={{ width: "50%" }}
                            className="form-input"
                            // title={
                            //   label === "Duration per Qn" && " (in seconds)"
                            // }
                            value={
                              key !== "totalDuration"
                                ? quizForm[key]
                                : `${
                                    quizForm.questionDuration *
                                    quizForm.totalQuestions
                                  }`
                            }
                            onChange={(e) =>
                              handleChange(key, Number(e.target.value))
                            }
                            required
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div style={{ display: "flex", gap: "2%" }}>
                    {/* {["start"].map((key, idx) => (
                      <div className="form-group" key={key}>
                        <label className="form-label">
                          {["Quiz Date"][idx]}
                        </label>
                        <input
                          type="datetime-local"
                          className="form-input"
                          value={quizForm[key]}
                          onChange={(e) => handleChange(key, e.target.value)}
                          required
                        />
                        {[
                          { key: "totalQuestions", label: "Total Question(s)" },
                          {
                            key: "questionDuration",
                            label: "Question Duration (in seconds)",
                          },
                        ].map(({ key, label }) => (
                          <div className="form-group" key={key}>
                            <label className="form-label">{label}</label>
                            <input
                              type="number"
                              className="form-input"
                              value={quizForm[key]}
                              onChange={(e) =>
                                handleChange(key, Number(e.target.value))
                              }
                              required
                            />
                          </div>
                        ))}
                      </div>
                    ))} */}
                    <div className="form-group">
                      <label className="form-label" style={{ fontWeight: 545 }}>
                        Icon for the Quiz
                      </label>
                      <input
                        type="file"
                        accept="image/*" // ✅ only allow images (icons)
                        onChange={(e) =>
                          setStatee((prev) => ({
                            ...prev,
                            icon: e.target.files[0], // ✅ store the uploaded file
                          }))
                        }
                      />
                    </div>
                    {[
                      { key: "totalQuestions", label: "Total Question(s)" },
                      {
                        key: "questionDuration",
                        label: "Question Duration (in seconds)",
                      },
                    ].map(({ key, label }) => (
                      <div className="form-group" key={key}>
                        <label
                          className="form-label"
                          style={{ fontWeight: 545 }}
                        >
                          {label}
                        </label>
                        <input
                          type="number"
                          className="form-input"
                          value={quizForm[key]}
                          onChange={(e) =>
                            handleChange(key, Number(e.target.value))
                          }
                          required
                        />
                      </div>
                    ))}
                  </div>
                )}
                {/* Questions + Duration */}
                {/* <div style={{ display: "flex", gap: "5%" }}>
                  {[
                    { key: "totalQuestions", label: "Total Question(s)" },
                    {
                      key: "questionDuration",
                      label: "Question Duration (in seconds)",
                    },
                  ].map(({ key, label }) => (
                    <div className="form-group" key={key}>
                      <label className="form-label">{label}</label>
                      <input
                        type="number"
                        className="form-input"
                        value={quizForm[key]}
                        onChange={(e) =>
                          handleChange(key, Number(e.target.value))
                        }
                        required
                      />
                    </div>
                  ))}
                </div> */}
                {/* Marks */}
                <div style={{ display: "flex", gap: "5%" }}>
                  <div className="form-group">
                    <label className="form-label" style={{ fontWeight: 545 }}>
                      Marks For Correct Answer
                    </label>
                    <input
                      type="number"
                      className="form-input form-control"
                      value={quizForm.correct}
                      onChange={(e) => handleChange("correct", e.target.value)}
                      required
                      min="1"
                    />
                  </div>

                  {[
                    {
                      key: "enableWrongMarks",
                      label: "Negative Marking For Wrong Answer",
                      inputKey: "wrong",
                    },
                    {
                      key: "enableSkippedMarks",
                      label: "Negative Marking For Skipped Answer",
                      inputKey: "skipped",
                    },
                  ].map(({ key, label, inputKey }) => (
                    <div className="form-group" key={key}>
                      <label className="form-label" style={{ fontWeight: 545 }}>
                        <input
                          type="checkbox"
                          checked={quizForm[key]}
                          onChange={(e) => handleChange(key, e.target.checked)}
                        />{" "}
                        {label}
                      </label>
                      {quizForm[key] && (
                        <input
                          type="number"
                          className="form-input"
                          placeholder={`Marks for ${inputKey}`}
                          value={quizForm[inputKey]}
                          min="0"
                          onChange={(e) =>
                            handleChange(inputKey, e.target.value)
                          }
                        />
                      )}
                    </div>
                  ))}
                </div>
                {/* Registration Fee */}
                {state.quizType === 1 && (
                  <>
                    <div style={{ display: "flex", gap: "5%" }}>
                      <div className="form-group mb-4">
                        <label
                          style={{ fontWeight: 545 }}
                          className="form-label block font-medium mb-2"
                        >
                          Registration Fee
                        </label>
                        <div
                          className="flex items-center gap-6"
                          style={{ display: "flex", gap: "2%" }}
                        >
                          {["free", "paid"].map((mode) => (
                            <label
                              className="inline-flex items-center"
                              style={{ fontWeight: 545 }}
                              key={mode}
                            >
                              <input
                                type="radio"
                                name="registrationFeeMode"
                                value={mode}
                                checked={quizForm.registrationFeeMode === mode}
                                onChange={(e) =>
                                  handleChange(
                                    "registrationFeeMode",
                                    e.target.value
                                  )
                                }
                                className="form-radio text-blue-600"
                                required
                              />
                              <span className="ml-2 capitalize">{mode}</span>
                            </label>
                          ))}
                        </div>
                        {quizForm.registrationFeeMode === "paid" && (
                          <div className="flex items-center gap-6 mt-2">
                            <label
                              className="inline-flex items-center"
                              style={{ fontWeight: 545 }}
                            >
                              Registration Cost
                              <input
                                type="number"
                                value={quizForm.registrationCost}
                                onChange={(e) =>
                                  handleChange(
                                    "registrationCost",
                                    e.target.value
                                  )
                                }
                                className="form-input"
                                required
                                min="1"
                              />
                            </label>
                          </div>
                        )}
                      </div>
                    </div>
                    <div>
                      <h4 style={{ fontSize: "16px", fontWeight: 545 }}>
                        Winner Prize Details
                      </h4>
                      <textarea
                        onChange={(e) =>
                          handleChange("prizeDescription", e.target.value)
                        }
                        value={prizeDescription}
                        className="form-control"
                        placeholder="Enter the winner price details..."
                      />
                    </div>
                    {/* <div className="form-group mt-4">
                      <label className="form-label">
                        Select Number of Top Winners
                      </label>
                      <select
                        className="form-input"
                        value={quizForm.topWinnersCount}
                        onChange={(e) =>
                          handleChange("topWinnersCount", e.target.value)
                        }
                      >
                        <option value={0}>None</option>
                        {Array.from({ length: 10 }, (_, i) => (
                          <option key={i + 1} value={i + 1}>
                            Top {i + 1}
                          </option>
                        ))}
                      </select>
                    </div>
                    {quizForm.topWinnersCount > 0 && (
                      <div className="mt-4">
                        <h4>Winner Prize Details</h4>
                        {Array.from(
                          { length: quizForm.topWinnersCount },
                          (_, index) => (
                            <div className="form-group" key={index}>
                              <label className="form-label">
                                Prize for Top {index + 1}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder={`Enter prize for Top ${index + 1}`}
                                value={quizForm.winnerPrizes[index] || ""}
                                onChange={(e) =>
                                  handlePrizeChange(index, e.target.value)
                                }
                              />
                            </div>
                          )
                        )}
                      </div>
                    )} */}
                    {/* winner price detauls */}

                    {/* Allotments */}
                    <div>
                      <h3
                        style={{
                          textAlign: "center",
                          fontSize: "20px",
                          marginTop: "2%",
                          fontWeight: 545,
                        }}
                      >
                        Question Allotment Form
                      </h3>
                      <div className="form-group">
                        <label
                          className="form-label"
                          style={{ fontWeight: 545 }}
                        >
                          Choose Difficulty Level(s)
                        </label>
                        <select
                          className="form-input"
                          onChange={(e) =>
                            handleAllotmentChange(e.target.value)
                          }
                          value=""
                        >
                          <option value="">Select</option>
                          {["basic", "advanced", "ultra", "docmaster"].map(
                            (level) => (
                              <option key={level} value={level}>
                                {level}
                              </option>
                            )
                          )}
                        </select>
                      </div>

                      <div style={{ marginTop: "10px" }}>
                        <strong>Total: </strong>
                        <span
                          style={{
                            color: totalAllotment === 100 ? "green" : "red",
                          }}
                        >
                          {totalAllotment}%
                        </span>{" "}
                        (must be exactly 100%)
                      </div>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr", // two per row
                          gap: "1rem",
                          marginTop: "1%",
                        }}
                      >
                        {state.allotments.map((each, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              gap: "1rem",
                              alignItems: "center",
                              border: "1px solid #ddd",
                              padding: "10px",
                              borderRadius: "8px",
                            }}
                          >
                            <p style={{ minWidth: "100px" }}>
                              <strong>{each.difficulty_level}</strong>
                            </p>
                            <input
                              type="number"
                              style={{
                                border: "1px solid gray",
                                borderRadius: "5px",
                                padding: "5px",
                              }}
                              // className="form-label form-input"
                              placeholder="Enter percentage"
                              value={each.percentage}
                              onChange={(e) =>
                                updatePercent(index, Number(e.target.value))
                              }
                            />
                            <button
                              type="button"
                              style={{ marginLeft: "auto" }}
                              onClick={() =>
                                removeAllotment(each.difficulty_level)
                              }
                            >
                              Remove
                            </button>
                          </div>
                        ))}
                      </div>

                      {/* {quizForm.allotments.map((each, index) => (
                <div
                  key={index}
                  style={{ display: "flex", gap: "2rem", marginBottom: "10px" }}
                >
                  <p style={{ minWidth: "100px" }}>
                    <strong>{each.difficulty_level}</strong>
                  </p>
                  <input
                    type="number"
                    className="form-input"
                    placeholder="Enter percentage"
                    value={each.percentage}
                    onChange={(e) =>
                      updatePercent(index, Number(e.target.value))
                    }
                  />
                </div>
              ))} */}
                    </div>
                  </>
                )}
                {state.quizType === 2 && (
                  <div>
                    <div className="form-group">
                      <label className="form-label" style={{ fontWeight: 545 }}>
                        Choose a Law
                      </label>
                      <select
                        className="form-control"
                        value={category}
                        onChange={(e) => {
                          setCategory(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {categories?.map((e) => (
                          <option key={e.id} value={e.id}>
                            {e.name}
                          </option>
                        ))}{" "}
                      </select>
                    </div>
                  </div>
                )}
                {/* About + Terms */}
                <h3
                  style={{
                    textAlign: "center",
                    fontSize: "20px",
                    fontWeight: 545,
                  }}
                >
                  Terms and conditions
                </h3>
                <div className="form-group">
                  <label className="form-label" style={{ fontWeight: 545 }}>
                    About Quiz
                  </label>
                  <textarea
                    className="form-input"
                    value={quizForm.about}
                    onChange={(e) => handleChange("about", e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label" style={{ fontWeight: 545 }}>
                    Terms and conditions
                  </label>
                  <div style={{ display: "flex", gap: "2%" }}>
                    <textarea
                      className="form-input"
                      style={{ height: "60vh" }}
                      value={quizForm.terms}
                      onChange={(e) => handleChange("terms", e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div
                  className="mt-4 p-3 border rounded bg-gray-50"
                  style={{ height: "30vh", overflow: "auto" }}
                >
                  <p>
                    <strong>Note:</strong>
                    Please ensure that the following variables are not removed
                    from the Terms and Conditions section above.
                  </p>
                  <p>
                    <strong>Variables used in the Terms and Conditions:</strong>
                    <ol>
                      <li>
                        [Number] – Represents the total number of questions in
                        the quiz.
                      </li>
                      <li>
                        [X seconds] – Represents the total duration of the quiz,
                        calculated as
                        <em>
                          {" "}
                          total questions × duration per question (in seconds)
                        </em>
                        .
                      </li>
                      <li>
                        [X second] – Represents the duration allocated for each
                        question (in seconds).
                      </li>
                      <li>
                        [Correct] – Represents the score awarded for each
                        correct answer.
                      </li>
                    </ol>
                  </p>
                </div>

                <div
                  className="mt-4 p-3 border rounded bg-gray-50"
                  style={{ height: "60vh", overflow: "auto" }}
                >
                  <h4
                    className="mb-2 font-semibold"
                    style={{ textAlign: "center" }}
                  >
                    Preview of Terms and Conditions
                  </h4>
                  {state.quizType === 2 && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: formatTerms(quizForm.terms),
                      }}
                    />
                  )}
                  {state.quizType === 1 && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: convertTermsToHtml(quizForm.terms),
                      }}
                    />
                  )}
                </div>

                <div className="text-center mt-4">
                  <button
                    className="btn btn-primary px-4 py-2 rounded"
                    // disabled={!isFormValid}
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </>
            ) : (
              <p>Please choose a quiz type</p>
            )}
          </div>
          <hr className="my-8 border-gray-300" />
        </div>
      </div>
    </div>
  );
}
